import { ReactNode } from 'react';

import { Avatar, AvatarProps } from '@sternum/ui';

import { Badge } from './Badge.component';

import { Container } from './AvatarWithBadge.style';

export interface AvatarWithBadgeProps extends AvatarProps {
  badge?: ReactNode;
}

export function AvatarWithBadge({ badge, ...props }: AvatarWithBadgeProps) {
  return (
    <Container>
      <Avatar {...props} />
      {badge}
    </Container>
  );
}

AvatarWithBadge.Badge = Badge;
